import React, { createContext, useContext } from 'react';
import { useMobileOS } from '@beef/react';
var OS;
(function (OS) {
  OS["Android"] = "android";
  OS["IOS"] = "ios";
})(OS || (OS = {}));
var PlatformContext = /*#__PURE__*/createContext(false);
var usePlatformContext = function usePlatformContext() {
  return useContext(PlatformContext);
};
export var IOS = function IOS(_ref) {
  var children = _ref.children;
  var os = useMobileOS();
  var ignorePlatforms = usePlatformContext();
  return os === OS.IOS || ignorePlatforms ? children : null;
};
export var Android = function Android(_ref2) {
  var children = _ref2.children;
  var os = useMobileOS();
  var ignorePlatforms = usePlatformContext();
  return os === OS.Android || ignorePlatforms ? children : null;
};
export var Desktop = function Desktop(_ref3) {
  var children = _ref3.children;
  var os = useMobileOS();
  var ignorePlatforms = usePlatformContext();
  return !os || ignorePlatforms ? children : null;
};
export var PlatformContainer = function PlatformContainer(_ref4) {
  var _ref4$ignorePlatforms = _ref4.ignorePlatforms,
    ignorePlatforms = _ref4$ignorePlatforms === void 0 ? false : _ref4$ignorePlatforms,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement(PlatformContext.Provider, {
    value: ignorePlatforms
  }, children);
};